//called from main.js in RootView
Backbone.Radio.channel('views').reply('modalRegion',function(){
	var dateRangeStart_1 	= moment("2025-06-18T06:00:00");
	var dateRangeEnd_1   	= moment("2025-06-28T23:59:59");
	var dateRangeStart_2  = moment("2025-06-29T06:00:00");
	var dateRangeEnd_2    = moment("2025-06-29T23:59:59");
	var dateRangeStart_3	= moment("2025-06-30T06:00:00");
	var dateRangeEnd_3    = moment("2025-06-30T23:59:59");
	var htm = ""


	if(moment().isBetween(dateRangeStart_1, dateRangeEnd_1)){
		htm +=			'<div id="modal" class="modal-stand" style="display: none;">'
		htm += 				'<div class="link-div">'
		htm+= 					'<a href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=Champion" class="modal-link">DONATE NOW</a>'
		htm += 				'</div>'
		htm +=			'</div>'
		htm +=			'<style>'
		htm +=				'.modal-stand {'
    	htm +=					'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHRO_lightbox_bkg.jpg") no-repeat transparent top center;'
		htm +=				'}'
		htm += 				'@media (max-width: 650px){' 
		htm +=					'.modal-stand {' 
		htm +=						'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHRO_lightbox_bkg_sm.jpg") no-repeat transparent top center;'
		htm +=					'}'
		htm +=					'.modal-stand .modal-link {' 
		htm +=						'margin-bottom: 13rem;'
		htm +=					'}'  
		htm +=				'}'
		htm += 				'@media (max-width: 433px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 75%;'
		htm +=						'margin-top: .6rem !important;'
		htm +=					'}' 
		htm +=				'}'
		htm += 				'@media (max-width: 354px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 60%;'
		htm +=						'margin-top: 1rem !important;'
		htm +=					'}'  
		htm +=				'}'
		htm +=			'</style>'
	}

	if(moment().isBetween(dateRangeStart_2, dateRangeEnd_2)){
		htm +=			'<div id="modal" class="modal-stand" style="display: none;">'
		htm += 				'<div class="link-div">'
		htm+= 					'<a href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=Champion" class="modal-link">DONATE NOW</a>'
		htm += 				'</div>'
		htm +=			'</div>'
		htm +=			'<style>'
		htm +=				'.modal-stand {'
    	htm +=					'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHRO2ndToLastDay_lightbox_bkg.jpg") no-repeat transparent top center;'
		htm +=				'}'
		htm += 				'@media (max-width: 650px){' 
		htm +=					'.modal-stand {' 
		htm +=						'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHRO2ndToLastDay_lightbox_bkg_sm.jpg") no-repeat transparent top center;'
		htm +=					'}'
		htm +=					'.modal-stand .modal-link {' 
		htm +=						'margin-bottom: 13rem;'
		htm +=					'}'  
		htm +=				'}'
		htm += 				'@media (max-width: 433px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 75%;'
		htm +=						'margin-top: .6rem !important;'
		htm +=					'}'
		htm +=					'.modal-stand .modal-link {' 
		htm +=						'margin-bottom: 2rem;'
		htm +=					'}'  
		htm +=				'}'
		htm += 				'@media (max-width: 354px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 60%;'
		htm +=						'margin-top: 1rem !important;'
		htm +=					'}'
		htm +=					'.modal-stand .modal-link {' 
		htm +=						'margin-bottom: 2rem;'
		htm +=					'}'  
		htm +=				'}'
		htm +=			'</style>'
	}

	if(moment().isBetween(dateRangeStart_3, dateRangeEnd_3)){
		htm +=			'<div id="modal" class="modal-stand" style="display: none;">'
		htm += 				'<div class="link-div">'
		htm+= 					'<a href="https://secure.whro.org/site/Donation2?1400.donation=form1&df_id=1400&set.custom.Package=Champion" class="modal-link">DONATE NOW</a>'
		htm += 				'</div>'
		htm +=			'</div>'
		htm +=			'<style>'
		htm +=				'.modal-stand {'
    	htm +=					'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHROLastDay_lightbox_bkg.jpg") no-repeat transparent top center;'
		htm +=				'}'
		htm += 				'@media (max-width: 650px){' 
		htm +=					'.modal-stand {' 
		htm +=						'background: url("https://pages.whro.org/assets/imgs/pledge/champion/championWHROLastDay_lightbox_bkg_sm.jpg") no-repeat transparent top center;'
		htm +=					'}'
		htm +=					'.modal-stand .modal-link {' 
		htm +=						'margin-bottom: 13rem;'
		htm +=					'}'  
		htm +=				'}'
		htm += 				'@media (max-width: 433px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 75%;'
		htm +=						'margin-top: .6rem !important;'
		htm +=					'}' 
		htm +=				'}'
		htm += 				'@media (max-width: 354px){' 
		htm +=					'.bannerLogo {' 
		htm +=						'max-height: 60%;'
		htm +=						'margin-top: 1rem !important;'
		htm +=					'}'  
		htm +=				'}'
		htm +=			'</style>'
	}
	    
    return new (Marionette.View.extend({
    	template: _.template(htm)
		,onAttach:function(){
			if ((moment().isBetween(dateRangeStart_1, dateRangeEnd_1)  || moment().isBetween(dateRangeStart_2, dateRangeEnd_2) || moment().isBetween(dateRangeStart_3, dateRangeEnd_3))  && $.cookie('modal') === undefined) {
				$('#modal').modal({
					modalClass: "modal-stand"
				});
				$.cookie('modal', (new Date().getTime()), {
					expires: 1,
					path: '/'
				});
			}
		}
    }))();
});